<template>
    <BButton
        variant="primary"
        :size="compact ? 'sm' : null"
        :disabled="isDisabled"
        @click="$emit('complete-step', step.id)"
    >
        {{ resolvedLabel }}
    </BButton>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
    name: 'WorkflowStepCompletionButton',
    components: {
        BButton,
    },
    props: {
        step: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        compact: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        resolvedLabel() {
            if (this.label) {
                return this.label
            }

            return typeof this.$t === 'function'
                ? this.$t('Component(Button):done-goto-next-step')
                : 'Done'
        },
        isDisabled() {
            return !this.step.isReachable
                || !this.step.isValid
                || this.step.isBusy
                || this.step.isLoading
                || this.step.isSaving
        },
    },
}
</script>
